module.exports = __webpack_public_path__ + "img/b53e08b.jpg";